export class AppStatsReportRequest {
    resultsUrl!: string;
    search: any = {};
    groupBy?: string;
}

export class AppStatsReportCountRequest extends AppStatsReportRequest {}

export class AppStatsReportSumRequest extends AppStatsReportCountRequest {
    field!: string;
    operation = 'sum';
    groupBySecondsRange?: number;
    groupBySecondsOffset?: number;
}
